import type { CSSProperties } from 'react';

const containerStyle: CSSProperties = {
  minHeight: '100dvh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1rem',
  fontFamily: 'system-ui, sans-serif',
  color: '#111',
  background: '#fafafa',
  padding: '2rem',
};

const codeStyle: CSSProperties = {
  fontSize: '0.75rem',
  color: '#888',
  fontFamily: 'ui-monospace, SFMono-Regular, monospace',
};

const buttonStyle: CSSProperties = {
  padding: '0.6rem 1.2rem',
  border: 'none',
  borderRadius: '0.5rem',
  background: '#111',
  color: '#fff',
  cursor: 'pointer',
  fontSize: '0.95rem',
};

export interface AppErrorScreenProps {
  code: string;
  onRetry: () => void;
  /** Sentry event ID surfaced to the user for support correlation (Fix #20). */
  traceId?: string;
}

const traceStyle: CSSProperties = {
  marginTop: '0.25rem',
  fontSize: '0.7rem',
  color: '#888',
  fontFamily: 'ui-monospace, SFMono-Regular, monospace',
};

export function AppErrorScreen({ code, onRetry, traceId }: AppErrorScreenProps) {
  return (
    <div style={containerStyle} role="alert">
      <img src="/hook-logo.svg" alt="Hook" width={48} height={48} />
      <h1 style={{ margin: 0, fontSize: '1.1rem' }}>
        Não conseguimos carregar este app
      </h1>
      <button style={buttonStyle} onClick={onRetry}>
        Tentar de novo
      </button>
      <code style={codeStyle}>{code}</code>
      {traceId ? (
        <span style={traceStyle}>
          ID de suporte: <code>{traceId}</code>
        </span>
      ) : null}
    </div>
  );
}
